module.exports = __webpack_public_path__ + "img/ico_product_default.695877ef.svg";